import { fetcher } from '@commenda/utils';
import { ICommendaOnboarding } from './types';

/**
 * Imperative fetch function for sales tax onboarding data.
 * Use this when you need to fetch onboarding data outside of React hooks (e.g., in Promise.all).
 */
export async function fetchOnboarding(
  corporationId: number
): Promise<{ success: boolean; data: ICommendaOnboarding | null }> {
  const response = await fetcher(
    `new-sales-tax/onboarding/corporation/${corporationId}`,
    { method: 'GET' }
  );

  if (!response.ok) {
    return { success: false, data: null };
  }

  // The endpoint returns the onboarding object itself, not `{ data }`.
  const data: ICommendaOnboarding | null = await response.json();
  return { success: true, data };
}
